import osIcon from "../assets/icons/os.png";
import sdgIcon from "../assets/icons/sdg.png";
import linkedinIcon from "../assets/icons/linkendin.png";

// Update this list with real products as needed
export const products = [
  {
    id: "explorer",
    title: "Himachal Tree Species Explorer",
    description: "Select a location to create a 50 km buffer and visualize distribution for 14 tree species across Himachal Pradesh.",
    icon: osIcon,
    to: "/products/hp-explorer",
  }
];
